import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox } from '@/_components';
import type { CompanyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';

import { useGetCompaniesMutation } from '../apis';

export function CompanyMultiSelectCombo(props: FormAsyncComboboxProps<CompanyQueryLinkerSchema, true>) {
  return (
    <FormAsyncCombobox
      {...props}
      isMulti
      showBorder
      itemToString={(item) => item.name}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      getMultiValueLabel={(item) => item.name}
      useApi={useGetCompaniesMutation}
    />
  );
}
